import { pubmatic } from '../../../__vendor/pubmatic';
import { shouldIncludeBidder } from '../../utils';
export const configurePermutive = (consentState) => {
    const shouldInclude = shouldIncludeBidder(consentState);
    const includedAcBidders = [
        'and',
        'ix',
        'ozone',
        'pubmatic',
        'trustx',
        'rubicon',
    ]
        .filter(shouldInclude)
        // "and" is the alias for the custom Guardian "appnexus" direct bidder
        .map((bidder) => (bidder === 'and' ? 'appnexus' : bidder));
    return {
        dataProviders: [
            {
                name: 'permutive',
                params: {
                    acBidders: includedAcBidders,
                    ...(includedAcBidders.includes('pubmatic')
                        ? { overwrites: { pubmatic } }
                        : {}),
                },
            },
        ],
    };
};
